import { Button } from "@mui/material";
import { Link } from "react-router-dom";

export default function FooterMenu() {
  const role_id = localStorage.getItem('role_id');

  const menuItems = role_id !== '100' ? [
    { label: 'INICIO', path: '/' },
    { label: 'QUIENES SOMOS', path: '/quienes-somos' },
    { label: 'BUSCADOR DE ENFERMERAS', path: '/enfermeras' },
    { label: 'MENSAJES', path: '/mensajes' },
    { label: 'BLOG', path: '/blog' },
  ] : [
    { label: 'Banners', path: '/banners' },
    { label: 'Usuarios', path: '/usuarios' },
    { label: 'Blog', path: '/admin-blog' },
    { label: 'Mensajes', path: '/admin-mensajes' },
    { label: 'Calificaciones', path: '/calificaciones' },
  ];

  return (
    <div id='footer_menu' className="menu-buttons">
      {menuItems.map((item) => (
        <Button
          key={item.label}
          component={Link}
          to={item.path}
          style={{ color: 'white' }}
        >
          {item.label}
        </Button>
      ))}
    </div>
  );
}